import styled from 'styled-components'

export const Menu = styled.nav`
  position: relative;
  z-index: 1;
`
